import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var listStyles = css(["position:relative;padding-bottom:12px;padding-left:18px;", " &:last-child{padding-bottom:24px;}", ";"], getFont(0), minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-left: 54px;\n  "]))));
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-vjm889-0"
})(["padding:24px 12px;border-radius:", ";background-color:#fff;"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
});
export var StyledArticle = styled.div.withConfig({
  displayName: "partials__StyledArticle",
  componentId: "sc-vjm889-1"
})(["color:", ";p{", " padding-bottom:12px;}ul{li{", ";", " padding-left:18px !important;&:before{left:-9px;width:20px;margin-right:9px;content:'\u2022';}}}ol{counter-reset:ol;li{", ";&:before{position:absolute;top:0;left:-15px;width:24px;height:24px;border-radius:50%;content:counter(ol);counter-increment:ol 1;background-color:", ";line-height:24px;color:#fff;text-align:center;", ";}}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.font;
}, getFont(0), listStyles, getFont(0), listStyles, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.secondary;
}, minMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          left: 12px;\n        "]))));